// extracted by mini-css-extract-plugin
export default {"detailsSection":"details-section_detailsSection__xE38A","row":"details-section_row__6ktTA","label":"details-section_label__hxEK-"};